export default {
    chatManage: {
        chat: '对话',
        stopOutput: '停止输出',
        pleaseEnterChatContent: '请输入聊天内容，Shift+Enter换行',
        send: '发送',
        fileSizeLessThan15MB: '文件大小需小于 15MB!',
        pleaseEnterContent: '请输入内容',
        imageUploadFailed: '图片上传失败',
        fileUploadFailed: '文件上传失败',
        client: '客户端：',
        exportChat: '导出会话记录',
        pleaseSelectClient: '请选择客户端',
        exportAllChat: '导出全部会话',
        exportPartialChat: '导出指定会话',
        all: '全部',
        unread: '未读',
        haveRead: '已读',
        noData: '暂无数据',
        manual: '人工',
        export: '导出',
        exportChatTitle: '导出会话',
        exportTip: '为避免数据量过大，请按会话时间筛选后导出，时间跨度须在{count}天内。',
        sessionTime: '会话时间',
        startDate: '开始日期',
        endDate: '结束日期',
        selectChatTip: '单次最多可选择30个会话导出',
        pleaseSelectChat: '请选择需要导出的对话记录',
        pleaseSelectTimeRange: '请选择时间范围',
        exportChatRecord: '会话记录导出',
        replyMode: '回复模式：',
        manualReply: '人工回复',
        aiReply: 'AI 回复',
        groupReply: '群组回复',
        transferToManual: '转人工',
        haveProcessed: '已处理',
        AICustomerProfile: 'AI客户档案',
        AIAssistantGenerateReply: 'AI辅助生成回复',
        confirmTransferToManual: '是否确认转成人工客服?',
        manualCustomerService: '人工客服',
        switchSuccess: '切换成功',
        confirmTransferToAI: '是否确认转成智能客服?',
        intelligentCustomerService: '智能客服',
        contentIsNotCompliant: '内容不合规，请换个问题吧~',
        copySuccess: '复制成功',
        pleaseEnterMessage: '请输入消息',
        NoPrivie: {
            title: '对话管理',
            description: '聚合管理智能体接入渠道的全部对话，AI回复/人工回复智能切换。一站式管理全渠道的对话用户，基于智能的数据分析添加客户标签、生成客户档案。',
            chatManage: '会话管理',
            chatManageDescription: '聚合展示全渠道用户与智能体的对话',
            chatManageDescription2: '消息实时同步，会话记录可导出',
            chatManageDescription3: '除AI回复外，支持辅助生成回复和人工回复',
            transferToManual: '转人工处理',
            transferToManualDescription: '支持配置不同人工客服的可见权限',
            transferToManualDescription2: '转人工后智能生成对话总结摘要卡片',
            transferToManualDescription3: 'AI回复/人工回复一键切换',
            customerManage: '客户管理',
            customerManageDescription: '一站式管理全渠道与智能体对话的用户',
            customerManageDescription2: '多种方式智能生成AI客户标签',
            customerManageDescription3: '一键直达客户档案',
        }
    }
};